// extracted by mini-css-extract-plugin
export default {"Container":"CollapsePanel_Container__Ui0IT","Header":"CollapsePanel_Header__hoOlV","Body":"CollapsePanel_Body__965oY"};